<template>
  <v-container>
    <v-row>
      <v-col offset="0" offset-lg="2">
        <h2 class="app-title">Significado das etapas do funil de vendas:</h2>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <Indicador
          title="Lead"
          icon="people_alt"
          text="Todo contato que entra no seu site e preenche um formulário de contato, com possível interesse em seu produto/serviço."
        />
      </v-col>

      <v-col cols="12">
        <Indicador
          title="Oportunidade"
          icon="star"
          text="Leads que se tornaram uma oportunidade de vendas, ou seja, se interessaram em seguir no funil de vendas e foram qualificados como uma possível venda pelo seu time comercial."
        />
      </v-col>

      <v-col cols="12">
        <Indicador
          icon="laptop_mac"
          title="Demonstrações"
          text="São os leads considerados oportunidades qualificadas, que se interessaram em assistir a uma demonstração ou apresentação do seu produto/serviço."
        />
      </v-col>

      <v-col cols="12">
        <Indicador
          icon="picture_as_pdf"
          title="Propostas"
          text="Leads que passaram por demonstrações e desejam receber propostas para comparar valores e partir para uma possível compra."
        />
      </v-col>

      <v-col cols="12">
        <Indicador
          icon="local_atm"
          title="Vendas"
          text="Fecharam/ assinaram um contrato e efetuaram pagamentos do produto. Se tornaram CLIENTES."
        />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import Indicador from './Indicador'
import './../App.css';
export default {
  components: { Indicador }
}
</script>

<style>
</style>